import React, { useState, useCallback} from "react";
import { getGroup} from "../../services/AnimalSplitCore";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function JoinById(props) {
  const {
    modalId,
    setIsLoading,
  } = props;

  const { t} = useTranslation();
  const [formValidated, setFormValidated] = useState(false);
  const [eventId, setEventId] = useState("");
  const [errorType, setErrorType] = useState("");
  const history = useHistory();

  const isValidId = useCallback(() => {
    return eventId.trim() !== "";
  }, [eventId]);

  const joinGroupById = useCallback(() => {
    if (!isValidId()) {
      setFormValidated(true);
      setErrorType("INVALID_ID_ERROR");
      return;
    }
    setIsLoading(true);

    getGroup(eventId)
      .then(({ payload }) => {
        setIsLoading(false);
        //destroy the back drop of this mode
        const dismissModal = document.getElementById(modalId);
        var bsDismissModal = window.bootstrap.Modal.getInstance(dismissModal);
        bsDismissModal.dispose();
        //jump to group page
        history.push(`${process.env.PUBLIC_URL}/group/${eventId}`);
      })
      .catch((error) => {
        setIsLoading(false);
        if(error && error.response && error.response.status === 500){
            setErrorType("INVALID_ID_ERROR");
            setFormValidated(false);
        }
      });
  }, [
    modalId,
    history,
    isValidId,
    setIsLoading,
    eventId
  ]);

  return (
    <div className="modal fade" id={modalId} tabIndex="-1">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title" id="exampleModalLabel">
              {t('event.join_by_id')}
            </h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
            >
            </button>
          </div>
          <div className={`modal-body ${formValidated ? "was-validated" : ""}`} >
            <label className="form-label">{t('event.event_id')}</label>
            <input
              type="text"
              className="form-control me-2"
              id="eventName"
              value={eventId}
              onChange={(e) => {
                setEventId(e.target.value)
                setErrorType("");
                setFormValidated(false);
              }}
              required = "required"
            />
            <div id="participantHelp" className="form-text">
              <div className = "text-danger">
                {errorType === "INVALID_ID_ERROR" ? ("Please provide a valid event ID.") : ("")}
              </div>
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              className="btn btn-secondary"
              data-bs-dismiss="modal"
            >
              {t('general.close')}
            </button>
            <button
              type="button"
              className="btn btn-primary"
              onClick={(e) => {
                e.preventDefault();
                joinGroupById();
              }}
            >
              {t("general.submit")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
